import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FiPower, FiMapPin } from "react-icons/fi";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaStickyNote,
  FaCamera,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import { MdOutlineEdit } from "react-icons/md";
import {
  IoLocationOutline,
  IoCameraOutline,
  IoImagesOutline,
} from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { RiFileList3Line } from "react-icons/ri";
import { LuNotebookPen } from "react-icons/lu";

export let reactIcons = {
  IoImagesOutlineIcon: IoImagesOutline as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  NoteIcon: LuNotebookPen as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  ReportIcon: RiFileList3Line as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  InfoIcon: IoMdInformationCircleOutline as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  LeftArrowIcon: FaChevronLeft as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  RightArrowIcon: FaChevronRight as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  IoCameraIcon: IoCameraOutline as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  EyeIcon: AiOutlineEye as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  EyeOffIcon: AiOutlineEyeInvisible as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  PowerIcon: FiPower as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  FaCalendarIcon: FaCalendarAlt as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  CalenderIcon: CiCalendar as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  FaMapMarkerIcon: FaMapMarkerAlt as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  MapPinIcon: FiMapPin as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  FaStickyIcon: FaStickyNote as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  EditIcon: MdOutlineEdit as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  FaCameraIcon: FaCamera as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
  IoLocationOutlineIcon: IoLocationOutline as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >,
  RxCrossIcon: RxCross1 as unknown as React.FC<React.SVGProps<SVGSVGElement>>,
};
